<script type="text/babel">
  export default {
    name: 'BaseSelectize',
    data() {
      return {
        options: null
      }
    },
    computed: {
      items() {
        if (this.selectedValues === null) {
          return []
        }

        if (Array.isArray(this.selectedValues)) {
          return  this.selectedValues.map((item) => {
            return item.id
          })

        } else if (typeof this.selectedValues === 'object') {
          return [this.selectedValues.id]
        }

      }
    },
    methods: {
      optionSelected(option) {
        this.$emit('optionSelected', option)
        if (this.valueField){
          this.$emit('input', option.id)
        }else{
          this.$emit('input', option)
        }
      },
      optionRemoved(option) {
        this.$emit('optionRemoved', option)
        this.$emit('input', null)
      },
    },
    props: {
      selectedValues: {
        default: null
      },
      selectedValue: {
        default: null
      },
      // set null for select multiple options
      maxItems: {
        default: 1,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      allowEmptyOption: {
        type: Boolean,
        default: false,
      },
      value:{
      },
      valueField:{
        default:null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BaseSelectize.vue?adff2bee